import { useEffect } from 'react';
import { useFormik } from 'formik';
import { OrbitCatalogEnum } from '../../../../shared/types/orbit';
import { useOrbitCatalog } from '../hooks/useOrbitCatalog';
import { initialValues, validationSchema } from './formData';
import { OrbitSpecialConditionProps } from '../sectionProps';

export const useOrbitSpecialCondition = ({
    onChangeFormik,
    readOnly,
    seedValues,
}: OrbitSpecialConditionProps) => {
    const formik = useFormik({
        initialValues: {
            ...initialValues,
            ...(readOnly && seedValues ? seedValues : {}),
        },
        validationSchema,
        enableReinitialize: readOnly,
        onSubmit: () => undefined,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors, formik.isValid]);

    useEffect(() => {
        if (readOnly || formik.values.hasSpecialCondition) return;
        formik.setFieldValue('specialCondition', '');
        formik.setFieldValue('observations', '');
    }, [formik.values.hasSpecialCondition, readOnly]);

    const {
        items: specialConditionOptions,
        loading: loadingSpecialConditions,
        error: specialConditionsError,
    } = useOrbitCatalog(OrbitCatalogEnum.SpecialConditions);

    return {
        formik,
        specialConditionOptions,
        loadingSpecialConditions,
        specialConditionsError,
    };
};
